import { Col, Modal, Row, Text } from '@app/components'
import React from 'react'

export const BurnPendingModal: React.FC<any> = ({ percent, setPercent }) => {
  //const step = Math.floor(percent / 33)

  return (
    <Modal
      //title="Confirm Burn in Wallet"
      open={percent > 0 && percent < 100}
      centered
      footer={false}
      width={1000}
      onCancel={() => setPercent(0)}
    >
      <Row>
        <Col span={24}>
          <Row>
            <Col span={24}>
              {/*<Steps current={step} size="small">
                <Steps.Step
                  description={
                    <div style={{ paddingTop: '30px', marginLeft: '120px', textAlign: 'center' }}>Burning</div>
                  }
                />
                <Steps.Step
                  description={
                    <div style={{ paddingTop: '30px', marginLeft: '110px', textAlign: 'center', width: '200px' }}>
                      Transferring your USD
                    </div>
                  }
                />
                <Steps.Step />
              </Steps>*/}
              <Text style={{ display: 'block', textAlign: 'center', fontSize: '48px', marginTop: '20px' }}>
                Confirm transfer in Wallet
              </Text>
              {/*<Progress type={'line'} percent={percent}/>*/}
              <Text style={{ display: 'block', textAlign: 'center', fontSize: '16px', marginTop: '20px' }}>
                Please stay on this page until the transaction completes!
              </Text>
              <Text style={{ display: 'block', textAlign: 'center', fontSize: '16px', marginTop: '20px' }}>
                You will be notified via email when your account has been credited
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  )
}
